import { render, staticRenderFns } from "./MultiLanguageInput.vue?vue&type=template&id=3d718502&"
import script from "./MultiLanguageInput.vue?vue&type=script&lang=js&"
export * from "./MultiLanguageInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports